import { API } from 'common/modules/ReactShared';
import * as Template from '../../../_pagination';

import { selectors } from './selectors';
import { IItem } from './types';

const slice: Template.tPaginationSlice<IItem> = Template.createPaginationSlice<IItem>({
  name: 'activeLessons',
  perPage: 24,
  getItemsRequest: async (params) => {
    const response = await API.Profile.Lessons.Active.getLessons({
      lesson_title_start: params.searchValue,
      page: params.page,
      per_page: params.perPage
    });
    const { lessons, ...pagination } = response;
    return { items: lessons, pagination };
  },
  removeItemRequest: (itemId) => {
    return API.Profile.Lessons.Active.deleteLesson(itemId);
  },
  selectors
});

const { reducer, actions } = slice;

export { reducer, actions };
